<template>
  <g v-on:contextmenu.prevent="requestContextmenu($event)">
    <circle cx="0" cy="0" r="20" stroke="black" stroke-width="2"
      v-bind:fill="statusColor" />
    <text x="0" y="40" text-anchor="middle">{{ name }}</text>
  </g>
</template>

<script>
  import Vue from 'vue'
  import EventHub from './EventHub'
  Vue.use(EventHub);

  export default {
    props: {
      id: String,
      name: String,
      status: String
    },
    computed: {
      statusColor: function () {
        if (this.status == "alive") return 'greenyellow';
        if (this.status == "dead") return 'darkgrey';
        if (this.status == "OK") return 'greenyellow';
        if (this.status == "WARNING") return 'yellow';
        if (this.status == "ERROR") return 'crimson';
        if (this.status == "NO_REPORT") return 'darkgrey';
        if (this.status == "NO_REPORT_LONG") return 'grey';
        return 'black'
      }
    },
    methods: {
      requestContextmenu: function (event) {
        this.$eventHub.$emit('node-contextmenu-requested', this.id, event);
      }
    }
  }
</script>

<style lang="sass" scoped>
  text
    user-select: none
</style>